////////GHG EF 3.3 schema
const threeThreeSchema = {
  title: "3.3 Fuel and Energy-related Activities(not included in Scope 1 or Scope 2)",
  cat: "4_1",
  catName: "cat4",
  progressiveOrderSwitch: {
    by: { level: 3, key: "computationMethod" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
      specialDataShouldIf: {
        level: 1,
        key: "ghgActivityNameId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    ////////Data Source
    {
      key: "emissionFactorTypeId",
      level: 2,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
      specialDataShouldIf: {
        level: 1,
        key: "ghgActivityNameId",
        notEmpty: true,
        formData: "EAFormData",
      },
    },
    ////////Computation Method
    {
      key: "computationMethod",
      level: 3,
      type: "select",
      label: "Computation Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "4_1",
      },
      showIf: {
        all: [
          { level: 2, key: "emissionFactorTypeId", ne: "2" },
          { level: 2, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "computationMethod",
      },
      showIf: { level: 3, key: "computationMethod", notEmpty: true },
      combineKey: 2,
    },
    //////// Material / Product / Asset Type
    {
      key: "assetType",
      level: 5,
      type: "select",
      label: "Material / Product / Asset Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: { level: 4, key: "sourceEFName", notEmpty: true },
      combineKey: 3,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 6,
      type: "select",
      label: "Material / Product / Asset Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "assetType",
      },
      showIf: {
        level: 5,
        key: "assetType",
        notEmpty: true,
      },
      combineKey: 4,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 6,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat4CustomEFDropdownList",
      showIf: {
        level: 2,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default threeThreeSchema;
